<div class="o-flex o-flex--justify-center margin-left-10">
  <mat-label class="visualization__label-before-slide u-font-weight-500">Evenly Spaced X-Axis</mat-label>
  <mat-slide-toggle (ngModelChange)="toggleCurrentType()" [ngModel]="isDateType">Time-Scaled X-Axis</mat-slide-toggle>
</div>
